module.exports = __webpack_public_path__ + "static/media/news-14.12412a4d.jpg";